import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="email-3, envelope" maskId="round-filled-radius-0-stroke-1.5-IconEmail3"><path d="M22 7.40197V4.75C22 4.33579 21.6642 4 21.25 4H2.75C2.33579 4 2 4.33579 2 4.75V7.40197C4.57249 9.93619 8.10362 11.5 12 11.5C15.8964 11.5 19.4275 9.93619 22 7.40197Z" fill="currentColor"/><path d="M22 9.4187C19.2802 11.6564 15.797 13 12 13C8.20301 13 4.71984 11.6564 2 9.4187V19.25C2 19.6642 2.33579 20 2.75 20H21.25C21.6642 20 22 19.6642 22 19.25V9.4187Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail3;
